import React, { useState, useEffect } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { getAuth } from "firebase/auth";
import { db } from "../firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";

// Import background image
import back7 from "./back1.png";

const UpdatePaymentMethod = () => {
  const stripe = useStripe();
  const elements = useElements();
  const auth = getAuth();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const [routingNumber, setRoutingNumber] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchStripeAccountId = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setStripeAccountId(userData.stripeAccountId || null);
          setEmail(user.email || "");
          setFullName(user.displayName || "");
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
      }
    };

    fetchStripeAccountId();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe) {
      setError("Stripe is not loaded yet. Please try again.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error("User not logged in.");
      }

      // Create a Stripe token for the bank account
      const { token, error: stripeError } = await stripe.createToken('bank_account', {
        country: 'US',
        currency: 'usd',
        routing_number: routingNumber,
        account_number: accountNumber,
        account_holder_name: fullName,
        account_holder_type: 'individual',
      });

      if (stripeError) {
        throw new Error(stripeError.message);
      }

      // Send token and user info to the backend to create or update the Stripe account
      const response = await fetch("https://us-central1-gearshare-41e19.cloudfunctions.net/api/update-stripe-account", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          stripeAccountId, 
          fullName,
          email,
          tokenId: token.id,
          userID: user.uid,
        }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to update payment method.");
      }

      // Update Firestore with the new or updated Stripe account ID
      await updateDoc(doc(db, "users", user.uid), {
        stripeAccountId: result.account.id,
      });
      setStripeAccountId(result.account.id);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${back7})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: "500px", margin: "auto", padding: "20px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Update Payment Method</h1>

        {error && (
          <div
            style={{
              color: "red",
              fontSize: "14px",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            {error}
          </div>
        )}

        {success && (
          <div
            style={{
              color: "green",
              fontSize: "14px",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            Payment method updated successfully!
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="fullName" style={{ display: "block", marginBottom: "5px" }}>
              Full Name:
            </label>
            <input
              id="fullName"
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="email" style={{ display: "block", marginBottom: "5px" }}>
              Email:
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="routingNumber" style={{ display: "block", marginBottom: "5px" }}>
              Routing Number:
            </label>
            <input
              id="routingNumber"
              type="text"
              value={routingNumber}
              onChange={(e) => setRoutingNumber(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="accountNumber" style={{ display: "block", marginBottom: "5px" }}>
              Account Number:
            </label>
            <input
              id="accountNumber"
              type="text"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
            />
          </div>
          <button
            type="submit"
            style={{
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              padding: "10px 20px",
              fontSize: "16px",
              cursor: "pointer",
              width: "100%",
            }}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Payment Method"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdatePaymentMethod;
